import React, { Component } from "react";

import { connect } from "react-redux";
import { Button } from "reactstrap";

import { Link } from "react-router-dom";

// Import menuDropdown

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

//Import i18n
import { withTranslation } from "react-i18next";

//Import Megamenu
import MegaMenu from "./MegaMenu";

// Redux Store
import { toggleRightSidebar } from "../../store/actions";

//Import logo Images
import logosmdark from "../../assets/images/logo-sm-dark.png";
import logodark from "../../assets/images/logo-dark.png";

//Import Social Profile Images

import DashDropdown from "./DasshDropdown/DashDropdown";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      isSocialPf: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightbar = this.toggleRightbar.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div
              className="d-flex align-items-center"
              style={{ width: "90%", height: "90px" }}
            >
              <div className="d-flex">
                <div className="navbar-brand-box">
                  <Link to="#" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logosmdark} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                      <img src={logodark} alt="" height="20" />
                    </span>
                  </Link>

                  <Link to="#" className="logo logo-light">
                    <span className="logo-sm">
                      <img
                        src={
                          "https://bermadize.in/static/media/blogo.5baccbf0.png"
                        }
                        alt=""
                        height="40"
                        width="40"
                      />
                    </span>
                    <span className="logo-lg">
                      <img
                        src={
                          "https://bermadize.in/static/media/bermadLogo.2332df61.png"
                        }
                        alt=""
                        height="50"
                        width="150"
                      />
                    </span>
                  </Link>
                </div>

                <Button
                  size="sm"
                  color="none"
                  type="button"
                  onClick={this.toggleMenu}
                  className="px-3 font-size-24 header-item waves-effect"
                  id="vertical-menu-btn"
                >
                  <i className="ri-menu-2-line align-middle"></i>
                </Button>

                <MegaMenu />
              </div>

              <div className="w-100 align-items-center">
                <DashDropdown />
              </div>
            </div>

            <div className="d-flex align-items-center">
              <ProfileMenu />
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(Header)
);
